import localForage from "localforage";

export default async function setStorage(key_name, key_value) {
	await localForage.setItem(key_name, key_value);
	return true;
}
